import { apiClient } from "lib/apiClient";

export const deletePropertyAttachments = async <T>(id: string): Promise<T> => {
  const response = await apiClient.delete(`/property/attachments/${id}
  `);

  return response.data;
};
